import { action } from 'typesafe-actions'

import { IntegrationCredential, IntegrationTypes } from './types'

interface UserInfo {
  username: string
  password: string
}
export const getIntegrationCredentials = () =>
  action(IntegrationTypes.GET_INTEGRATION_CREDENTIALS)

export const getIntegrationCredentialsFailure = (message: string) =>
  action(IntegrationTypes.GET_INTEGRATION_CREDENTIALS_FAILURE, { message })

export const getIntegrationCredentialsSuccess = (
  list: IntegrationCredential[]
) => action(IntegrationTypes.GET_INTEGRATION_CREDENTIALS_SUCCESS, { list })

export const setIntegrationCredential = (payload: UserInfo) =>
  action(IntegrationTypes.SET_INTEGRATION_CREDENTIAL, payload)

export const setIntegrationCredentialFailure = (message: string) =>
  action(IntegrationTypes.SET_INTEGRATION_CREDENTIAL_FAILURE, { message })
